export { default as Img200 } from './processed/200/Fatal-Vows-3.jpg';
export { default as Img400 } from './processed/400/Fatal-Vows-3.jpg';
export { default as Imgthumb } from './processed/thumb/Fatal-Vows-3.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Fatal-Vows-3.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Fatal-Vows-3.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      79,
      142,
      189
    ],
    "_population": 2385,
    "_hsl": [
      0.5712121212121212,
      0.4545454545454546,
      0.5254901960784314
    ]
  },
  "LightVibrant": {
    "_rgb": [
      138,
      199,
      224
    ],
    "_population": 139,
    "_hsl": [
      0.5484496124031008,
      0.581081081081081,
      0.7098039215686274
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      39,
      73,
      92
    ],
    "_population": 1258,
    "_hsl": [
      0.559748427672956,
      0.40458015267175573,
      0.2568627450980392
    ]
  },
  "Muted": {
    "_rgb": [
      130,
      139,
      108
    ],
    "_population": 1854,
    "_hsl": [
      0.21505376344086022,
      0.1255060728744939,
      0.484313725490196
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      191,
      182
    ],
    "_population": 182,
    "_hsl": [
      0.06818181818181814,
      0.17741935483870974,
      0.7568627450980392
    ]
  },
  "DarkMuted": {
    "_rgb": [
      46,
      78,
      58
    ],
    "_population": 1119,
    "_hsl": [
      0.3958333333333333,
      0.2580645161290323,
      0.2431372549019608
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Fatal-Vows-3.js